import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const AllStudents = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStudents, setFilteredStudents] = useState([]);

  useEffect(() => {
    fetch('https://api.myskills.lk/std/allstudents')
      .then((response) => response.json())
      .then((data) => {
        setStudents(data);
        setFilteredStudents(data); // Initialize filteredStudents with all data
      })
      .catch((error) => console.error('Error fetching students:', error));
  }, []);

  // Real-time filtering effect
  useEffect(() => {
    if (!searchTerm.trim()) {
      // If search is empty, show all students
      setFilteredStudents(students);
      return;
    }
    
    // Filter students based on multiple fields
    const filtered = students.filter(student => 
      (student.name && student.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.address && student.address.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.district && student.district.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.province && student.province.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.phone && student.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.mobile && student.mobile.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.email && student.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.school && student.school.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.course && student.course.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (student.category && student.category.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    
    setFilteredStudents(filtered);
  }, [searchTerm, students]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    // No need for e.preventDefault() since we want it to update as we type
  };

  const handleDelete = async (studentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this student?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`https://api.myskills.lk/std/delete/${studentId}`, {
            method: 'DELETE',
          });

          if (response.ok) {
            const updatedStudents = students.filter(student => student.id !== studentId);
            setStudents(updatedStudents);
            setFilteredStudents(updatedStudents.filter(student => 
              !searchTerm || 
              (student.name && student.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
              (student.email && student.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
              // Other filter conditions as in the useEffect
              (student.course && student.course.toLowerCase().includes(searchTerm.toLowerCase()))
            ));
            Swal.fire({
              title: "Deleted!",
              text: "The student has been deleted.",
              icon: "success"
            });
          } else {
            const errorResponse = await response.json();
            console.error('Failed to delete student:', errorResponse);
            Swal.fire({
              title: "Error!",
              text: `Failed to delete student: ${errorResponse.message}`,
              icon: "error"
            });
          }
        } catch (error) {
          console.error('Error deleting student:', error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete the student.",
            icon: "error"
          });
        }
      }
    });
  };

  return (
    <div>
      <AdminDashboard />

      <div className='AllViews-admin-course'>
        <div className="search-icon-admin admin-course-search">
          <h1>ALL STUDENTS</h1>
          <form>
            <input 
              type="text" 
              value={searchTerm}
              onChange={handleSearch} 
              placeholder='Search Item' 
            />
            <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
          </form>
        </div>

        <div className="scroller-box">
          <div className="table-course">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Address</th>
                  <th>District</th>
                  <th>Province</th>
                  <th>Phone</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>School</th>
                  <th>Course</th>
                  <th>Category</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.length > 0 ? (
                  filteredStudents.map((student) => (
                    <tr key={student.id}>
                      <td>{student.name}</td>
                      <td>{student.address}</td>
                      <td>{student.district}</td>
                      <td>{student.province}</td>
                      <td>{student.phone}</td>
                      <td>{student.mobile}</td>
                      <td>{student.email}</td>
                      <td>{student.school}</td>
                      <td>{student.course}</td>
                      <td>{student.category}</td>
                      <td id='action-buttons'>
                        <a href="#!" id='del-details' onClick={() => handleDelete(student.id)}>DELETE</a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" style={{textAlign: 'center'}}>No students found matching your search</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllStudents;
